import { render, staticRenderFns } from "./ReviewDrawing.vue?vue&type=template&id=30edddac&"
import script from "./ReviewDrawing.vue?vue&type=script&lang=js&"
export * from "./ReviewDrawing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports